module.exports = __webpack_public_path__ + "static/media/service_onlinePlatform.6e19f939.png";